import { reducer } from './users';

export default reducer;
